import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

interface NoResultsProps {
  callbacks: {
    reset: () => void,
  },
}

const NoResults = (props: NoResultsProps) => {
  const { callbacks: { reset } } = props

  return (
    <Box flexDirection="column" marginTop="medium" variant="white">
      <DashboardModuleListItem
        onClick={reset}
        title="No Results"
      >
        <Text color="bodyFontLightColor">Show All</Text>
      </DashboardModuleListItem>
    </Box>
  )
}

export default NoResults
